import type { Locale } from './types';

const configuredDefaultLocale = String(import.meta.env.VITE_DEFAULT_LOCALE ?? 'zh').toLowerCase();
export const defaultLocale: Locale = configuredDefaultLocale === 'en' ? 'en' : 'zh';

export const copy = {
  zh: {
    textExtractionTitle: '字幕文本提取',
    extractText: '提取字幕文本',
    extractingText: '正在读取字幕',
    extractedText: '提取结果',
    copyText: '复制文本',
    copied: '已复制',
    textExtractionFailed: '字幕文本提取失败',
    subtitleTrack: '字幕轨道',
    autoSelectTrack: '自动选择可用字幕轨',
    subtitleLanguage: '字幕语言',
    autoDetectLanguage: '自动选择语言',
    textSource: '来源',
    cueCount: '字幕条目',
    cueUnit: '条',
    textTrackBoundary: '仅读取媒体已有的文字字幕轨，不进行语音识别或画面 OCR；无字幕以及烧录在画面中的硬字幕无法提取。',
    embeddedTrackAttempt: '页面未列出外部字幕，将尝试读取视频内嵌的文字字幕轨。',
    manualSubtitle: '人工字幕',
    automaticCaption: '平台自动字幕',
    embeddedSubtitle: '内嵌文字字幕',
    unknownSubtitleSource: '字幕轨',
    noTextTrack: '没有找到可读取的文字字幕轨。语音和烧录在画面中的字幕不在本功能处理范围内。',
    navWorkbench: '解析工作台',
    navHistory: '解析历史',
    navVip: '会员方案',
    signIn: '登录',
    signOut: '退出',
    account: '账户',
    language: 'EN',
    eyebrow: 'A CALMER WAY TO SAVE THE INTERNET',
    title: '把链接，变成一段\n可以带走的媒体。',
    subtitle: '复制公开页面链接，交给 JunVideo。我们会识别来源、整理可用格式，并把下载入口放在一个清爽的工作区里。',
    inputPlaceholder: '粘贴抖音、小红书、Bilibili 等媒体链接…',
    parse: '开始解析',
    parsing: '正在解析',
    loginToParse: '登录后解析',
    supported: '优先支持',
    pasteTip: '支持公开可访问的页面链接，不处理 DRM 或付费墙内容。',
    quotaTitle: '今日用量',
    unlimited: '无限制',
    timesLeft: '次剩余',
    quotaHint: '普通账户每日 10 次，VIP 不限次数。',
    upgrade: '开通 VIP',
    activeVip: 'VIP 已生效',
    resultTitle: '解析结果',
    ready: '已准备好下载',
    noResult: '结果会出现在这里',
    noResultHint: '粘贴一个链接，开始你的第一次解析。',
    video: '视频',
    audio: '音频',
    captions: '字幕',
    subtitles: '字幕轨道',
    coverImage: '封面图片',
    image: '图',
    images: '图片',
    views: '播放',
    likes: '点赞',
    videoFormats: '视频格式',
    sourceDescription: '查看来源简介',
    extractorsReady: '个站点提取器已就绪',
    download: '下载',
    downloadRetry: '重试',
    refreshParse: '重新解析',
    downloadFailed: '下载失败',
    mediaStream: '媒体流',
    source: '来源',
    duration: '时长',
    author: '作者',
    recent: '最近解析',
    viewAll: '查看全部',
    emptyHistory: '还没有解析记录',
    emptyHistoryHint: '你完成的解析会在这里留下轻量记录。',
    stepsTitle: '三步，拿到你需要的格式',
    stepOne: '复制链接',
    stepOneHint: '在平台分享菜单中复制公开页面链接。',
    stepTwo: '粘贴解析',
    stepTwoHint: 'JunVideo 识别平台并整理可用媒体格式。',
    stepThree: '选择下载',
    stepThreeHint: '选择视频、音频或图片，直接保存到本地。',
    platformsTitle: '为常用平台做好准备',
    platformsHint: '平台适配器独立存在，后续可以平滑增加新的来源。',
    loginTitle: '登录 JunVideo',
    registerTitle: '创建你的 JunVideo',
    loginHint: '登录后即可开始解析，并同步历史记录。',
    registerHint: '免费注册，每天享有 10 次解析额度。',
    name: '昵称',
    email: '邮箱',
    password: '密码',
    namePlaceholder: '例如：Jun',
    emailPlaceholder: 'you@example.com',
    passwordPlaceholder: '至少 8 位字符',
    loginAction: '登录',
    registerAction: '注册并开始',
    switchToRegister: '还没有账户？去注册',
    switchToLogin: '已有账户？去登录',
    close: '关闭',
    vipTitle: '让灵感不被次数打断',
    vipSubtitle: 'VIP 适合需要连续整理素材的创作者。产品目前处于公开测试阶段，正式订阅开放后会在这里更新。',
    vipSubtitleDev: 'VIP 适合需要连续整理素材的创作者。当前开发环境可直接开通测试权益。',
    monthly: '月度会员',
    monthlyPrice: '¥ 18',
    monthlyUnit: '/ 月',
    vipFeatureOne: '每日解析不限次数',
    vipFeatureTwo: '优先使用新平台适配器',
    vipFeatureThree: '历史记录更长时间保留',
    activate: '开发版开通 VIP',
    comingSoon: '公测期间暂未开放',
    activated: 'VIP 已开通',
    vipExpires: '有效期至',
    devBillingNote: '当前为本地开发权益，不会产生真实扣款。',
    publicBetaNote: '正式订阅尚未开放，不会产生扣款。',
    errorFallback: '这次解析没有完成，请稍后重试。',
    parserUnavailable: '解析引擎尚未安装。请在服务端安装 yt-dlp，或开启 PARSER_MODE=mock 进行界面测试。',
    invalidLink: '请输入媒体链接，可直接粘贴带或不带 https:// 的地址。',
    legal: '请只下载你有权保存的内容，并遵守来源平台的服务条款与版权规则。JunVideo 不绕过 DRM、登录墙或付费墙。',
    footer: '轻量、透明、可扩展的媒体链接工作台。',
    systemOnline: '服务在线',
    systemChecking: '检查服务中',
    database: '数据库',
    parser: '解析引擎',
    notConfigured: '未配置',
    available: '可用',
    unavailable: '未安装',
    status: '状态',
    failed: '解析失败',
  },
  en: {
    textExtractionTitle: 'Subtitle text extraction',
    extractText: 'Extract subtitle text',
    extractingText: 'Reading subtitles',
    extractedText: 'Extracted text',
    copyText: 'Copy text',
    copied: 'Copied',
    textExtractionFailed: 'Subtitle text extraction failed',
    subtitleTrack: 'Subtitle track',
    autoSelectTrack: 'Automatically select a text track',
    subtitleLanguage: 'Subtitle language',
    autoDetectLanguage: 'Automatically select a language',
    textSource: 'Source',
    cueCount: 'Cues',
    cueUnit: 'cues',
    textTrackBoundary: 'Reads existing text subtitle tracks only. It does not run speech recognition or screen OCR; videos without subtitles and burned-in captions cannot be extracted.',
    embeddedTrackAttempt: 'No external track was listed. JunVideo will try an embedded text subtitle track.',
    manualSubtitle: 'Manual subtitles',
    automaticCaption: 'Platform automatic captions',
    embeddedSubtitle: 'Embedded text subtitles',
    unknownSubtitleSource: 'Subtitle track',
    noTextTrack: 'No readable text subtitle track was found. Speech and captions burned into the picture are outside this feature.',
    navWorkbench: 'Workbench',
    navHistory: 'History',
    navVip: 'Membership',
    signIn: 'Sign in',
    signOut: 'Sign out',
    account: 'Account',
    language: '中文',
    eyebrow: 'A CALMER WAY TO SAVE THE INTERNET',
    title: 'Turn a link into\nmedia you can take with you.',
    subtitle: 'Paste a public page link into JunVideo. We identify the source, collect available formats, and keep every download within one calm workspace.',
    inputPlaceholder: 'Paste a Douyin, Xiaohongshu, Bilibili link…',
    parse: 'Parse link',
    parsing: 'Parsing',
    loginToParse: 'Sign in to parse',
    supported: 'Priority support',
    pasteTip: 'Public page links only. DRM and paywalled content are not handled.',
    quotaTitle: 'Today\'s usage',
    unlimited: 'Unlimited',
    timesLeft: 'left',
    quotaHint: 'Free accounts get 10 parses a day. VIP removes the cap.',
    upgrade: 'Get VIP',
    activeVip: 'VIP active',
    resultTitle: 'Parse result',
    ready: 'Ready to download',
    noResult: 'Your result will appear here',
    noResultHint: 'Paste a link to make your first parse.',
    video: 'Video',
    audio: 'Audio',
    captions: 'Subtitles',
    subtitles: 'subtitle tracks',
    coverImage: 'Cover image',
    image: 'Image',
    images: 'Images',
    views: 'views',
    likes: 'likes',
    videoFormats: 'video formats',
    sourceDescription: 'View source description',
    extractorsReady: 'site extractors ready',
    download: 'Download',
    downloadRetry: 'Retry',
    refreshParse: 'Re-parse',
    downloadFailed: 'Download failed',
    mediaStream: 'Media stream',
    source: 'Source',
    duration: 'Duration',
    author: 'Author',
    recent: 'Recent parses',
    viewAll: 'View all',
    emptyHistory: 'No parse history yet',
    emptyHistoryHint: 'Completed parses will leave a lightweight record here.',
    stepsTitle: 'Three steps to the format you need',
    stepOne: 'Copy the link',
    stepOneHint: 'Copy a public page link from the platform share menu.',
    stepTwo: 'Paste and parse',
    stepTwoHint: 'JunVideo identifies the platform and formats available media.',
    stepThree: 'Choose a download',
    stepThreeHint: 'Pick video, audio, or images and save them locally.',
    platformsTitle: 'Ready for your everyday platforms',
    platformsHint: 'Each platform adapter is independent, so new sources can be added cleanly.',
    loginTitle: 'Sign in to JunVideo',
    registerTitle: 'Create your JunVideo',
    loginHint: 'Sign in to parse and keep your history in sync.',
    registerHint: 'Free accounts receive 10 parses every day.',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    namePlaceholder: 'For example, Jun',
    emailPlaceholder: 'you@example.com',
    passwordPlaceholder: 'At least 8 characters',
    loginAction: 'Sign in',
    registerAction: 'Register and start',
    switchToRegister: 'New here? Create an account',
    switchToLogin: 'Already have an account? Sign in',
    close: 'Close',
    vipTitle: 'Keep inspiration moving',
    vipSubtitle: 'VIP is for creators who organize media continuously. JunVideo is currently in public beta; paid subscriptions will appear here when ready.',
    vipSubtitleDev: 'VIP is for creators who organize media continuously. This development environment can activate test access instantly.',
    monthly: 'Monthly membership',
    monthlyPrice: '¥ 18',
    monthlyUnit: '/ month',
    vipFeatureOne: 'Unlimited daily parsing',
    vipFeatureTwo: 'Priority access to new adapters',
    vipFeatureThree: 'Longer history retention',
    activate: 'Activate VIP in dev mode',
    comingSoon: 'Coming after public beta',
    activated: 'VIP activated',
    vipExpires: 'Valid until',
    devBillingNote: 'Local development entitlement. No real charge is made.',
    publicBetaNote: 'Paid subscriptions are not open yet. No charge will be made.',
    errorFallback: 'This parse did not finish. Please try again.',
    parserUnavailable: 'The parsing engine is not installed. Install yt-dlp on the server or use PARSER_MODE=mock for UI testing.',
    invalidLink: 'Enter a media link; https:// is optional when pasting.',
    legal: 'Only download content you have the right to save, and follow the source platform\'s terms and copyright rules. JunVideo does not bypass DRM, login walls, or paywalls.',
    footer: 'A light, transparent, extensible workspace for media links.',
    systemOnline: 'Service online',
    systemChecking: 'Checking service',
    database: 'Database',
    parser: 'Parser',
    notConfigured: 'Not configured',
    available: 'Available',
    unavailable: 'Not installed',
    status: 'Status',
    failed: 'Parse failed',
  },
} as const;

export type CopyKey = keyof typeof copy.zh;

export function t(locale: Locale, key: CopyKey) {
  return copy[locale][key] ?? copy.zh[key];
}
